// 'use client';

import React from "react";
// import dynamic from 'next/dynamic';
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
// import { Desktop as DesktopIcon } from '@phosphor-icons/react/dist/ssr/Desktop';
// import { DeviceTablet as DeviceTabletIcon } from '@phosphor-icons/react/dist/ssr/DeviceTablet';
// import { Phone as PhoneIcon } from '@phosphor-icons/react/dist/ssr/Phone';
import ApexChart from "react-apexcharts";
// const ApexChart = dynamic(() => import('react-apexcharts'), { ssr: false, loading: () => null });
export const Chart = styled(ApexChart)``;

// const iconMapping = { Desktop: DesktopIcon, Tablet: DeviceTabletIcon, Phone: PhoneIcon };

function BarChart ({ yearSales }) {
  const labels = ["January", "February"];
  const sx = { height: "100%" };
  const sales = yearSales?.map(e => parseFloat(e.totalSales));
  const months = yearSales?.map(e => e.month);
  const chartOptions = useChartOptions(labels);
  const chartSeries = sales;
  function add (accumulator, a) {
    return accumulator + parseInt(a);
  }
  return (
    <div sx={sx}>
      <CardHeader title='Yearly Sales' />
      <CardContent>
        
       {chartSeries?.length > 0 ? <Stack spacing={2}>
          <Chart
            height={180}
            options={chartOptions}
            series={chartSeries}
            type='donut'
            width='100%'
          />
          <Stack direction='row' spacing={2} style={{ justifyContent: "", textAlign: "center" }}>
            {chartSeries?.map((item, index) => {
              const label = labels[index];
              // const Icon = iconMapping[label];

              return (
                <Stack key={label} spacing={0}>
                  {/* {Icon ? <Icon fontSize="var(--icon-fontSize-lg)" /> : null} */}
                  <Typography variant='h6'>{label}</Typography>
                  <Typography color='text.secondary' variant='subtitle2' style={{fontWeight: '500'}}>
                    ₴{item}
                  </Typography>
                </Stack>
              );
            })}
            <Stack key={"Total"} spacing={0}>
              {/* {Icon ? <Icon fontSize="var(--icon-fontSize-lg)" /> : null} */}
              <Typography variant='h6'>{"Total Sales"}</Typography>
              <Typography color='text.secondary' style={{fontWeight: '500'}} variant='subtitle2'>
                {chartSeries?.length && "₴" + chartSeries.map(e => e).reduce(add, 0)}
                {/* ₴4380 */}
              </Typography>
            </Stack>
          </Stack>
        </Stack> : <Stack spacing={2}><div style={{ fontSize: "14px" }}>No Sales Yet!</div></Stack>}
      </CardContent>
    </div>
  );
}

function useChartOptions (labels) {
  const theme = useTheme();

  return {
    chart: { background: "transparent" },
    colors: ["#008ffb", "#00e396"],
    dataLabels: {
      enabled: false,
    },
    labels,
    legend: { show: true },
    fill: {
      type: "gradient",
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        // donut: {
        //   labels: {
        //     show: true,
        //     total: {
        //       showAlways: true,
        //       show: true,
        //     },
        //   },
        // },
      },
    },
    states: { active: { filter: { type: "none" } }, hover: { filter: { type: "none" } } },
    stroke: { width: 0 },
    // theme: { mode: theme.palette.mode },
    tooltip: { fillSeriesColor: false },
  };
}

export default BarChart;
